import { PayoutSettings } from "@wingspanhq/wingspan-api-sdk";

/**
 * The account's instant payout fee, as a percentage. `undefined` when the
 * payout settings have not loaded yet, or when the account has no fee
 * configured — callers must not substitute a placeholder percentage, since a
 * wrong number reads as data (PLA-3558).
 */
export const selectorPayoutSettingsInstantFee = (
  payoutSettings?: PayoutSettings
): number | undefined => payoutSettings?.accountInstantPayoutFee?.percentage;
